import type Extent from '@arcgis/core/geometry/Extent';

export function GeoFromExtent(extent: Extent): number[][] {
  const { xmax: _xmax, xmin: _xmin, ymax: _ymax, ymin: _ymin } = extent;
  const _geo = [];
  _geo.push([_xmin, _ymin]);
  _geo.push([_xmin, _ymax]);
  _geo.push([_xmax, _ymax]);
  _geo.push([_xmax, _ymin]);
  _geo.push([_xmin, _ymin]);

  return _geo;
}
